{
  "contentFiltering": {
    "errors": {
      "conentBlock": "At least one text is required",
      "ecoScoreDataSource": "At least one source is required",
      "ecoScoreDisplayMode": "Ecoscore display mode is required",
      "primaryProductAttributes": "At least one primary product attribute is required",
      "standardsToShow": "At least one standard must be selected"
    }
  },
  "design": {
    "error": {
      "configurationsNotFound": "An error (configuration not found) occurred while loading the design settings. Please try again later or contact support@traceforgood.com.",
      "generic": "An unexpected error occurred while loading the design settings. Please try again later or contact support@traceforgood.com.",
      "stylingParametersNotFound": "An error (style parameters not found) occurred while loading the design settings. Please try again later or contact support@traceforgood.com.",
      "title": "Error"
    },
    "noProductSheetGroup": {
      "message": "Please contact support@traceforgood.com to activate the design studio.",
      "title": "Upgrade your plan"
    },
    "update": {
      "error": {
        "message": "An unexpected error occurred during the update.",
        "title": "Error"
      },
      "success": {
        "message": "Your changes have been saved and will be visible on your e-commerce site within six hours.",
        "title": "Congratulations!"
      }
    }
  },
  "lockedFeatureOverlay": {
    "contentFiltering": {
      "buttonText": "Request a demo",
      "message": "Take control and enrich the product passport content.",
      "title": "Upgrade your plan"
    },
    "designStudio": {
      "buttonText": "Request a demo",
      "message": "Align your product passports’ design with your internal brand guidelines to ensure consistent omnichannel storytelling for your customers.",
      "title": "Upgrade your plan"
    },
    "languages": {
      "buttonText": "Request a demo",
      "message": "Enable additional languages for your product passports.",
      "title": "Upgrade your plan"
    }
  },
  "logoDelete": {
    "error": {
      "message": "An unexpected error occurred while deleting your logo.",
      "title": "Error"
    },
    "success": {
      "message": "Logo successfully deleted.",
      "title": "Deleted"
    }
  },
  "logoUpload": {
    "error": {
      "message": "An unexpected error occurred while updating your logo.",
      "title": "Error"
    }
  },
  "tabs": {
    "content": {
      "componentModal": {
        "componentTypeDisabledTooltip": "You have reached the maximum number of {{maxInstances}} instances for this component.",
        "componentTypeLabel": "Component type",
        "componentTypeLockedTooltip": "You need to upgrade your plan to unlock this component.",
        "create": {
          "error": {
            "message": "An unexpected error occurred while creating the component.",
            "title": "Error"
          },
          "success": {
            "message": "The {{componentType}} section is now active and will be visible within the eligible products’ passports within the next 6 hours.",
            "title": "Congratulations!"
          },
          "title": "Share an initiative"
        },
        "createButton": "Add to passport",
        "descriptions": {
          "LOGO": {
            "description": "Upload your logo to display it alongside initiatives in your product passports. You can adjust design settings in the dedicated section of the Design tab.",
            "helpText": "Drag and drop or click to select an image file for your logo",
            "title": "Upload Logo"
          },
          "PRODUCT_ATTRIBUTES": {
            "description": "Choose the product information to share with your customers. If two distinct characteristics share the exact same value, it will be displayed only once. You can distinguish primary information from secondary information for differentiated display.",
            "title": "Product Information"
          }
        },
        "ecoscore": {
          "cost": "Cost",
          "description": "This block shows a product’s environmental impact in its passport. The cost can be sourced from the Ecobalyse module (if active) or from your product catalog. Choose the source for both the cost and its accuracy rate, which Smart Display rules can use to show the cost only when it meets the required level of reliability.",
          "infoTitle": "Environmental cost",
          "label": "Cost",
          "labelTooltip": "Select the source of the environmental cost to display in the product passport. You can choose the Ecobalyse score (if the module is active) or an environmental cost attribute imported into your product catalog.",
          "placeholder": "Select a source",
          "title": "Warning",
          "warning": "In order to comply with the environmental labelling publishing rules, you must declare enrolled products’ information on theADEME  <link1>website</link1>. Trace for good makes it simple with a dedicated export available <link2>here</link2> (select the Eco-score claims for ADEME export option)."
        },
        "error": {
          "permissions": "Could not find components permissions, please refresh the page"
        },
        "selectorPlaceholder": "Select an initiative to share",
        "update": {
          "button": "Update",
          "error": {
            "message": "An unexpected error occurred while updating the component.",
            "title": "Error"
          },
          "success": {
            "message": "The {{componentType}} component has been updated successfully.",
            "title": "Congratulations!"
          }
        }
      },
      "components": {
        "ACTIVITY_LIST": "Product journey steps without icons",
        "BULLETED_LIST": "Bulleted list",
        "DETAILED_PRODUCT_COMPOSITION": "Detailed product composition",
        "ECOSCORE": "Environmental cost",
        "GENERIC_PASSPORT_TITLE": "Generic title",
        "LOGO": "Brand Logo",
        "ORGANIZATION_TITLE": "Brand name",
        "PACKAGING_INFO": "Packaging info",
        "POWERED_BY": "Powered by",
        "PRODUCT_ATTRIBUTES": "Product Information",
        "PRODUCT_IMAGE": "Product Visual",
        "RECYCLED_MATERIALS_INFO": "Recycled materials info",
        "TEXT_HEADER": "Custom initiative (title)",
        "TEXT_PARAGRAPH": "Custom initiative (paragraph)",
        "TEXT_PARAGRAPH_V2": "Custom initiative",
        "TRIMAN_FOOTER": "Triman footer without Trace for good's logo"
      },
      "componentsEditor": {
        "createComponent": "Share more",
        "subtitle": "Active highlights shared with your customers through the product passports. Dynamic rules and conditions might apply and override the content of a product’s passport.",
        "title": "CSR initiatives & commitments"
      },
      "contentFiltering": {
        "ecoScoreDisplayMode": {
          "label": "Target audience",
          "placeholder": "Select a target audience",
          "subtitle": "Dynamic display option for the environmental cost obtained for your products.",
          "title": "Environmental Cost",
          "tooltip": "Target audience refers to the intended recipients of product passport content. In this context, it specifies whether the environmental cost display is for B2B (business-to-business) or B2C (business-to-consumer) use. This distinction is important: B2C displays must follow strict regulatory requirements and use an official badge format, while B2B displays only require plain text showing the cost value.",
          "update": {
            "error": {
              "message": "An unexpected error occurred while updating the environmental cost display mode.",
              "title": "Error"
            },
            "success": {
              "message": "The environmental cost display mode has been updated successfully.",
              "title": "Congratulations!"
            }
          }
        },
        "standardsConfiguration": {
          "update": {
            "error": {
              "message": "An unexpected error occurred while updating the standards and certifications.",
              "title": "Error"
            },
            "success": {
              "message": "The standards and certifications have been updated successfully.",
              "title": "Congratulations!"
            }
          }
        },
        "standardsToShow": {
          "emptyMessage": "No active standard or certification in your organisation settings.",
          "label": "Eligible standards & certifications",
          "labelTooltip": "Select the standards and certifications that will be displayed within a compliant product's passport.",
          "placeholder": "Select eligible standards and certifications",
          "subtitle": "Setup dynamic highlights for the standards and certifications your products achieve.",
          "title": "Standards & certifications"
        },
        "subtitle": "Rules and conditions protect your brand image and ensure only accurate, reliable and relevant information is shared within the products’ passports.",
        "title": "Smart display"
      },
      "editProductComponentModal": {
        "cancelButton": "Cancel",
        "error": {
          "message": "message",
          "title": "title"
        },
        "saveButton": "Save",
        "success": {
          "message": "Content updated successfully",
          "title": "Congratulations !"
        }
      },
      "header": {
        "subtitle": "Publish the right information, at the right time, for a truthful and reliable communication aligned with your CSR commitments and brand image.",
        "title": "Product passport content"
      },
      "label": "Content",
      "logoModal": {
        "changeLogo": "Change logo",
        "removeLogo": "Remove logo"
      },
      "productAttributes": {
        "options": {
          "brand": "Brand",
          "brandReference": "Product reference",
          "collection": "Collection",
          "color": "Color",
          "name": "Product name",
          "purchaseOrderReference": "Purchase order reference"
        },
        "primary": {
          "emptyMessage": "No primary product attributes selected",
          "label": "Primary product attributes",
          "labelTooltip": "Select the primary product attributes that will be displayed within a compliant product's passport.",
          "placeholder": "Select primary product attributes"
        },
        "primaryProductAttributes": {
          "error": {
            "too_small": "at least one primary product attribute must be selected"
          }
        },
        "secondary": {
          "emptyMessage": "No secondary product attributes selected",
          "label": "Secondary product attributes",
          "labelTooltip": "Select the secondary product attributes that will be displayed within a compliant product's passport.",
          "placeholder": "Select secondary product attributes"
        },
        "secondaryProductAttributes": {
          "error": {
            "too_small": "at least one secondary product attribute must be selected"
          }
        }
      },
      "tooltip": "Communicate your commitments with an elected and secured content that showcase your products and broader CSR initiatives to your customers.",
      "updateProductPageComponents": {
        "deleteComponent": {
          "areYouSureText": "Are you sure you want to delete this component, all translations and content will be lost",
          "cancelText": "Cancel",
          "confirmText": "Delete",
          "error": {
            "message": "Failed to delete component",
            "title": "Error"
          },
          "success": {
            "message": "Component deleted",
            "title": "Deleted"
          }
        },
        "success": {
          "message": "Your changes will be visible within the eligible products' passports within the next 6 hours.",
          "title": "Congratulations"
        }
      }
    },
    "design": {
      "categories": {
        "activities": "Traceability section",
        "detailedProductComposition": "Composition section",
        "ecoscore": "Environmental labelling (eco-score) section ",
        "footer": "Footer",
        "genericPassportTitle": "Generic title",
        "global": "Page body",
        "logo": "Brand logo",
        "mainHeader": "Product information",
        "organizationTitle": "Brand name",
        "packagingInfo": "Other qualities and environmental features section",
        "productAttributes": "Product Information",
        "productImage": "Product Image",
        "searchEngine": "Search engine"
      },
      "enums": {
        "align": {
          "center": "Center",
          "end": "End",
          "left": "Left",
          "right": "Right",
          "start": "Start"
        },
        "flexAlign": {
          "flexEnd": "End",
          "flexStart": "Start"
        },
        "textDecoration": {
          "lineThrough": "Line Through",
          "overline": "Overline",
          "underline": "Underline"
        },
        "textTransform": {
          "capitalize": "Capitalize",
          "lowercase": "Lowercase",
          "none": "None",
          "uppercase": "Uppercase"
        }
      },
      "header": {
        "subtitle": "Ensure your customers enjoy a consistent visual experience across channels, with product passports and the associated search engine aligned with your brand guidelines.",
        "title": "Passport & Search Engine appearence"
      },
      "label": "Design",
      "style": {
        "activities": {
          "activitiesDepth": "Show ... steps",
          "activity": {
            "props": {
              "fontSize": "Step (size)",
              "fontWeight": "Step (weight)",
              "letterSpacing": "Step (letter spacing)",
              "lineHeight": "Line height",
              "textTransform": "Step (text case)"
            }
          },
          "country": {
            "props": {
              "fontSize": "Country (size)",
              "fontWeight": "Country (weight)",
              "letterSpacing": "Country (letter spacing)",
              "textTransform": "Country (text case)"
            }
          },
          "showActivityIcons": "Show icons",
          "showCertificates": "Show certificates",
          "showCountryFlags": "Show flags"
        },
        "appHeader": {
          "backgroundColor": "Background 2 (color)",
          "marginBottom": "Intermediate margin"
        },
        "backgroundColor": "Background 1 (color)",
        "contentBlocks": {
          "props": {
            "gap": "Sections (spacing)"
          }
        },
        "contentVerticalSpacing": "Sections (title/paragraph spacing)",
        "detailedProductComposition": {
          "content": {
            "color": "Component & Material (color)",
            "fontFamily": "Component & Material (font family)",
            "fontSize": "Component & Material (size)",
            "fontWeight": "Component & Material (weight)",
            "paddingBottom": "Component & Material (padding bottom)",
            "textAlign": "Component & Material (alignment)",
            "textTransform": "Component & Material (text case)"
          },
          "title": {
            "color": "Title (color)",
            "fontFamily": "Title (font family)",
            "fontSize": "Title (size)",
            "fontWeight": "Title (weight)",
            "letterSpacing": "Title (letter spacing)",
            "lineHeight": "Title (line height)",
            "paddingBottom": "Title (padding bottom)",
            "textAlign": "Title (alignment)",
            "textDecoration": "Title (text decoration)",
            "textTransform": "Title (text case)"
          }
        },
        "ecoscore": {
          "ecoscoreAlign": {
            "value": "Badge position"
          },
          "ecoscoreB2b": {
            "fontSize": "Font size",
            "fontWeight": "Font weight",
            "textAlign": "Alignment",
            "textTransform": "Text transform"
          }
        },
        "fontFamily": "Font family",
        "footer": {
          "lastUpdate": {
            "fontSize": "Update (size)",
            "fontWeight": "Update (weight)"
          },
          "marginBottom": "Bottom margin",
          "marginTop": "Top margin",
          "showLastUpdateTimestamp": "Show update date",
          "showPoweredByTFG": "Show Trace for Good logo"
        },
        "genericPassportTitle": {
          "background": "Background (color)",
          "color": "Title (color)",
          "fontFamily": "Title (font family)",
          "fontSize": "Title (size)",
          "fontWeight": "Title (weight)",
          "letterSpacing": "Title (letter spacing)",
          "lineHeight": "Title (line height)",
          "textAlign": "Title (alignment)",
          "textDecoration": "Title (decoration)",
          "textTransform": "Title (case)"
        },
        "headerFontFamily": "Headings (font family)",
        "headerFontSize": "Headings (size)",
        "headerFontWeight": "Headings (weight)",
        "headerLineHeight": "Headings (line height)",
        "headerTextDecoration": "Headings (decoration)",
        "headerTextTransform": "Headings (text case)",
        "height": "Total height",
        "letterSpacing": "Letter spacing",
        "lineHeight": "Line height",
        "logo": {
          "height": "Logo (height)",
          "logoAlign": "Logo alignment",
          "logoFile": "Logo file",
          "width": "Logo (width)"
        },
        "mainContainer": {
          "props": {
            "justifyContent": "Text alignment",
            "letterSpacing": "Letter spacing",
            "textAlign": "Text alignment",
            "textTransform": "Text case"
          }
        },
        "organizationTitle": {
          "backgroundColor": "Brand name (background color)",
          "color": "Brand name (color)",
          "fontFamily": "Brand name (font family)",
          "fontSize": "Brand name (size)",
          "fontWeight": "Brand name (weight)",
          "textAlign": "Brand name (alignment)",
          "textTransform": "Brand name (text case)"
        },
        "packagingInfo": {
          "marginBottom": "Bottom margin",
          "packagingInfoHeader": {
            "fontWeight": "Header (weight)",
            "textTransform": "Header (text case)"
          },
          "packagingInfoHyperLink": {
            "color": "Scan4Chem link (color)",
            "fontWeight": "Scan4Chem link (weight)",
            "textDecoration": "Scan4Chem link (decoration)"
          },
          "recycledPackagingKeyInfo": {
            "fontWeight": "Key info (weight)"
          }
        },
        "paddingBlock": "Sections (spacing 2)",
        "paddingInline": {
          "value": "Whitespace"
        },
        "productAttributes": {
          "primaryInformation": {
            "color": "Primary information (color)",
            "fontFamily": "Primary information (font family)",
            "fontSize": "Primary information (size)",
            "fontWeight": "Primary information (weight)",
            "textAlign": "Primary information (alignment)",
            "textTransform": "Primary information (text case)"
          },
          "productAttributesContainer": {
            "alignItems": "Alignment",
            "gap": "Spacing",
            "marginBottom": "Margin bottom"
          },
          "secondaryInformation": {
            "color": "Secondary information (color)",
            "fontFamily": "Secondary information (font family)",
            "fontSize": "Secondary information (size)",
            "fontWeight": "Secondary information (weight)",
            "textAlign": "Secondary information (alignment)",
            "textTransform": "Secondary information (text case)"
          }
        },
        "productImage": {
          "height": "Height",
          "imageAlign": "Image alignment",
          "width": "Width"
        },
        "searchEngine": {
          "backgroundColor": "Background (color 1)",
          "fontFamily": "Font family",
          "productCardBadgeBackgroundColor": {
            "value": "Collection badge (color 1)"
          },
          "productCardBadgeTextColor": {
            "value": "Collection badge (color 2)"
          },
          "searchEngineHeader": {
            "backgroundColor": "Background (color 2)",
            "color": "Text (color 1)"
          },
          "searchEngineTextColor": {
            "value": "Text (color 2)"
          }
        },
        "textColor": {
          "value": "Paragraph (color)"
        },
        "textFontSize": "Paragraph (size)",
        "textFontWeight": {
          "value": "Paragraph (weight)"
        },
        "titleColor": {
          "value": "Headings (color)"
        },
        "width": "Width"
      },
      "tooltip": "Align your product passport designs with your internal branding to deliver a consistent omnichannel narrative.",
      "tooltips": {
        "activitiesDepth": "Maximum number of production steps to show to customers when available.",
        "showCertificates": "Displayed certificates are linked to the information collected."
      }
    },
    "general": {
      "communicationMaterials": {
        "productPassports": {
          "deactivated": "URLs and QR codes are unavailable. Contact support@traceforgood.com to activate your communication plan.",
          "message": "Each product has a URL and QR code available on its detail page.",
          "title": "Passports"
        },
        "searchEngine": {
          "deactivated": "unavailable",
          "mainURL": "Search engine URL",
          "printableQRCode": "Printable QR code for the search engine",
          "title": "Product Passport & Search Engine"
        },
        "subtitle": "Find access links and other associated communication material details here.",
        "title": "Communication Materials"
      },
      "label": "General",
      "subscriptionPlanChangeSuccess": {
        "message": "Your subscription plan has been changed and you can now access the new features.",
        "title": "Subscription plan changed successfully!"
      },
      "subscriptionPlanModal": {
        "areYouSureText": "Are you sure you want to change your subscription plan to {{name}}?",
        "cancelText": "Cancel",
        "confirmText": "Confirm",
        "title": "Change Subscription Plan"
      },
      "subscriptionPlans": {
        "ADVANCED": {
          "description": "Enhance your product passports with impactful visuals and activate a third language to expand your international reach.",
          "name": "ADVANCED"
        },
        "EXPERT": {
          "description": "Access the full range of design customization settings to align your communication with your brand guidelines and deliver a tailored omnichannel experience to your consumers.",
          "name": "EXPERT"
        },
        "NONE": {
          "name": "No subscription plan selected"
        },
        "STARTER": {
          "description": "Activate the search engine and product passports in their standard version, and translate their content into two languages, including English.",
          "name": "STARTER"
        },
        "subtitle": "Reach out to our team at support@traceforgood.com to schedule a demo or upgrade your plan.",
        "title": "Subscription Plans"
      },
      "tooltip": "Boost the visibility of your traceability initiatives with a tailored communication plan and intelligent tools like the product passport, search engine, multiple QR codes, and shareable links."
    },
    "languages": {
      "activeLanguages": {
        "maxLanguagesSelectedReached": {
          "infoBox": {
            "message": "You've reached the maximum number of languages allowed by your plan. You may remove one or contact support@traceforgood.com to upgrade your plan if you wish to add another.",
            "title": "Maximum number of languages reached"
          }
        },
        "subtitle": "Target your core audience in their language and increase the global reach of your communication materials with impactful translations.",
        "title": "Active languages"
      },
      "label": "Languages",
      "tooltip": "Directly address your core audience and improve the international reach of your communications by managing translations for content (titles, paragraphs, production steps, and more).",
      "translations": {
        "subtitle": "Manage translations for the published content (titles, paragraphs, production steps, and more) in all active languages to comply with your marketing strategy and brand image guidelines.",
        "title": "Translations"
      }
    }
  },
  "title": "Communication Studio"
}
